<template>
    <div class="badge badge-category">
        <span :style="{ height: '8px', width: '8px', backgroundColor: category.color, borderRadius: '50%', display: 'inline-block' }"></span>
        <span class="my-0 ml-0 mr-1 text-muted" :title="tooltipTitle" style="padding-left: 5px;">{{ category.name }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            category: {
                type: Object,
                required: true
            }
        },
        computed: {
            tooltipTitle() {
                // Assuming you have a method to translate 'post.post_in_xx_category'
                // Replace this with your actual translation logic or method
                return `Post in ${this.category.name} category`; // Adjust this based on how you handle translations
            }
        }
    };
</script>
